import { UnauthorizedError } from '@magicdoorinc/errors';
import * as Sentry from '@sentry/browser';
import { DEV } from 'solid-js';
import { getEnv } from '~/utils/env';
import type { LogEntry } from '@magicdoorinc/auth';

type Mechanism = {
  handled?: boolean;
};

export const initSentry = () => {
  if (DEV) return;

  Sentry.init({
    dsn: 'https://753a14b2b69bc21a4d0577fb441f57df@sentry.magicdoor.io/5',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: getEnv(),
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'fetch') {
        const responseHeaders = hint?.response.headers as Headers;
        if (breadcrumb.data && responseHeaders) {
          breadcrumb.data.trace_id = responseHeaders?.get('x-trace-id');
        }
      }
      return breadcrumb;
    },
  });

  registerErrorHandler();
};

export const registerErrorHandler = () => {
  window.onunhandledrejection = (event) => {
    sentryCapture(event.reason as Error);
  };
};

export const sentryCapture = (error?: Error) => {
  if (DEV) return;
  const mechanism: Mechanism = {};

  if (error) {
    if (error instanceof UnauthorizedError) return;
    Sentry.captureException(error, { mechanism });
  }
};

export const uploadAuthLog = (log: LogEntry) => {
  Sentry.setTag('auth_flow_id', log.authFlowID);

  const uniqueId = `${log.authFlowID}-${Date.now()}`;

  const authLogError = new Error(log.level.toUpperCase() + ' - ' + log.type);
  authLogError.name = 'AuthLog';

  Sentry.captureException(authLogError, {
    level: 'debug',
    fingerprint: [uniqueId],
    extra: {
      log,
      uniqueId,
    },
  });
};
